import { render, staticRenderFns } from "./UnitBasicForm.vue?vue&type=template&id=955f6a9e&scoped=true&"
import script from "./UnitBasicForm.vue?vue&type=script&lang=js&"
export * from "./UnitBasicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955f6a9e",
  null
  
)

export default component.exports